// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-ff34e7d8] {\n  vertical-align: bottom;\n}\n.box[data-v-ff34e7d8] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n}\n.bg[data-v-ff34e7d8] {\n  width: 100vw;\n}\n.btn[data-v-ff34e7d8] {\n  width: 80vw;\n  position: fixed;\n  bottom: 16vw;\n}", ""]);
// Exports
module.exports = exports;
